import { useState, useEffect, useRef } from 'react';
import { FORM_ACTION_STATUS, } from '../types';
import { generateUUID } from '@wix/form-schema';
export const useFormActionsNew = ({ wfActionsV2, wfResultsV2, }) => {
    const [formActions, setFormActions] = useState({});
    const [inProgress, setInProgress] = useState(false);
    const unresolvedActions = useRef(new Map());
    useEffect(() => {
        if (!wfResultsV2) {
            return;
        }
        unresolvedActions.current.forEach((promiseHandler, actionId) => {
            if (!wfResultsV2[actionId] ||
                wfResultsV2[actionId].status === FORM_ACTION_STATUS.PENDING) {
                setInProgress(true);
                return;
            }
            if (wfResultsV2[actionId].status === FORM_ACTION_STATUS.FAILURE) {
                promiseHandler.reject(wfResultsV2[actionId].result);
            }
            if (wfResultsV2[actionId].status === FORM_ACTION_STATUS.SUCCESS) {
                promiseHandler.resolve(wfResultsV2[actionId].result);
            }
            unresolvedActions.current.delete(actionId);
            setInProgress(unresolvedActions.current.size > 0);
        });
    }, [wfResultsV2]);
    useEffect(() => {
        if (!wfActionsV2) {
            return;
        }
        const actions = Object.entries(wfActionsV2).reduce((acc, [actionName, actionFunction]) => {
            acc[actionName] = (...args) => {
                const correlationId = generateUUID();
                actionFunction(correlationId, ...args);
                return new Promise((resolve, reject) => {
                    unresolvedActions.current.set(correlationId, { resolve, reject });
                });
            };
            return acc;
        }, {});
        setFormActions(actions);
    }, [wfActionsV2]);
    return {
        formActions,
        inProgress,
    };
};
//# sourceMappingURL=use-form-actions-new.js.map